import React, { useState } from "react";
// import { Link } from "react-router-dom";
import "../../index.scss";

//Panels
import Modal from "../../../Modal/Modal";

//Images
import walkways1 from "../../../images/categories/walkways/PPI-walkway-001.jpg";
import walkways2 from "../../../images/categories/walkways/PPI-walkway-002.jpg";
import walkways3 from "../../../images/categories/walkways/PPI-walkway-003.jpg";
import walkways4 from "../../../images/categories/walkways/PPI-walkway-004.jpg";
import walkways5 from "../../../images/categories/walkways/PPI-walkway-005.jpg";
import walkways6 from "../../../images/categories/walkways/PPI-walkway-006.jpg";
import walkways7 from "../../../images/categories/walkways/PPI-walkway-007.jpg";
import walkways8 from "../../../images/categories/walkways/PPI-walkway-008.jpg";
import walkways9 from "../../../images/categories/walkways/PPI-walkway-009.jpg";
import walkways10 from "../../../images/categories/walkways/PPI-walkway-010.jpg";
import walkways11 from "../../../images/categories/walkways/PPI-walkway-011.jpg";
import walkways12 from "../../../images/categories/walkways/PPI-walkway-012.jpg";

//Utils
import { mapGallery } from "../../../../../Utils/Utils";

// SEO
import SEO from "../../../../../SEO/index.js";
import StructuredData from "../../../../../SEO/structuredData";

const Walkways = () => {
  const [showModal, setShowModal] = useState(false);
  const [current, setCurrent] = useState(0);

  const images = [
    {
      image: walkways1,
      description:
        "Paving stone walkway for the Pasadena Showcase House of Design 2019 at Descanso Gardens in La Canada, CA. This curving pathway features multiple styles of pavers, landscape lighting, water fountains and a lush water feature.",
      aria: "Curving paving stone walkway with landscape lighting, water fountains and a lush water feature",
    },
    {
      image: walkways2,
      description:
        "Winding pathway with ornate water feature in the center. This gray paving stone pathway connects the backyard patio space to the front yard driveway in a refined way.",
      aria: "Gray winding paving stone pathway with ornate water feature in the center",
    },
    {
      image: walkways3,
      description:
        "Concrete stone pathway in artificial turf. This design was completed for the 2017 Pasadena Showcase House of Design and was featured on HGTV.",
      aria: "Concrete stone pathway in artificial turf leading to patio and outdoor furniture",
    },
    {
      image: walkways4,
      description:
        "Earth-tone paving stone  side yard walkway for a home in Santa Clarita, CA.",
      aria: "Earth-tone paving stone side yard walkway for a home in Santa Clarita, CA",
    },
    {
      image: walkways5,
      description:
        "Lush garden pathway constructed with paving stones. The pavers are laid in a way to draw your eyes to the colorful water feature in the center of the design. Flanked by vibrant plants, this walkway is the focal point of the backyard.",
      aria: "Lush garden pathway constructed with paving stones flanked by vibrant plants",
    },
    {
      image: walkways6,
      description:
        "Traditional concrete slab walkway leading to the front door of this Burbank home.",
      aria: "Traditional concrete slab walkway leading to the front door of this Burbank home",
    },
    {
      image: walkways7,
      description:
        "Paving stone pathway leading from covered patio space to the pool area. By using the same pavers for both the patio and pool deck, we were able to create a seamless pathway from the two areas.",
      aria: "Paving stone pathway leading from covered patio space to the pool area",
    },
    {
      image: walkways8,
      description:
        "Brick-colored paving stone garden walkway leading to a covered patio space.",
      aria: "Brick-colored paving stone garden walkway leading to a covered patio space",
    },
    {
      image: walkways9,
      description:
        "Walkway with a small step leading to a large patio. This  understated garden walkway is complete with a flowing waterfall and drought tolerant landscaping.",
      aria: "Walkway with a step leading to a large patio with a flowing waterfall & drought tolerant plants",
    },
    {
      image: walkways10,
      description:
        "Matching Paving stone driveway and garden pathway leading throughout the backyard. This forked walkway segments a grass area from a lush garden and also leads to a covered patio space.",
      aria: "Matching Paving stone driveway and garden pathway leading throughout a backyard",
    },
    {
      image: walkways11,
      description:
        "Modern geometric pathway with artificial turf and stamped concrete. This modern walkway perfectly blends into the home’s aesthetic and is also a low maintenance option because of the durable and long lasting  materials used.",
      aria: "Geometric pathway with artificial turf and stamped concrete surround by plants",
    },
    {
      image: walkways12,
      description:
        "Modern side yard constructed from paving stones with shotcrete retaining wall leading to a wood deck and seating area. Deck has step lighting to illuminate the elevation change.",
      aria: "Paving stone side yard with shotcrete retaining wall leading to a wood deck & seating area",
    },
  ];

  return (
    <>
      <SEO
        title="Paver Walkway Ideas | Southern California | Pacific Pavingstone"
        description="View the beautiful paver walkway projects we've completed in Southern California. Gain inspiration and ideas for your next project today!"
        profileURL={"https://www.pacificpavingstone.com/gallery/walkways"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          name: "Completed Paver Walkway Gallery",
          description:
            "View the beautiful paver walkway projects we've completed in Southern California. Gain inspiration and ideas for your next project today!",
          image:
            "https://www.pacificpavingstone.com/static/media/steps-banner.744e284e.jpg",
          URL: "https://www.pacificpavingstone.com/contact-us",
        }}
      />
      <div className="container-fluid no-side-padding gallery-wrapper">
        {/* <div className="row justify-content-center hero-unit">
          <div className="col-12 no-side-padding">
            <div className="title">
              <Link to="/gallery">Back to Gallery</Link>
              <h1>Outdoor Kitchen Gallery</h1>
            </div>
          </div>
        </div> */}
        <div className="row justify-content-center">
          <div className="col-11">
            <div className="row gallery-images">
              {mapGallery(images, "outdoorkitchen", setShowModal, setCurrent)}
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          items={images}
          current={current}
        />
      </div>
    </>
  );
};

export default Walkways;
